import React, { useEffect, useState } from "react";
// import NewScheduleInterview from '../interview/NewScheduleInterview'
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ReshceduleForAction from "../interview/RescheduleForAction";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { FaCheck } from "react-icons/fa6";
import { MdOutlineCancel } from "react-icons/md";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextareaAutosize,
} from "@mui/material";
import DeactivateModal from "../../Common/DeactivateMemberModal";
import axios from "axios";
import Swal from 'sweetalert2';

import { SpinLoader } from "../ImportCandidates";
import { Toast, ToastContainer, toast } from "react-toastify";
import { CandidateInterviewPlanned } from "./../../../Redux/action/CandidateInterviewPlanned";
import { JobsInterviewPlannedAcceptAction } from "./../../../Redux/action/JobsInterviewPlannedAcceptAction";

// -----------------------------------------------------------------------------------------------------

const RequestedProfileTable = ({ interviewList, limit, pathname }) => {
  const { userResult } = useSelector((state) => state.Auth);
  const navigate = useNavigate();
  console.log("INTERVIEW-------e-----", interviewList);
  const arr = [1];
  const location = useLocation();
  const [canInfo, setCanInfo] = useState("");
  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState(""); // To store the selected reason
  const [showOtherTextarea, setShowOtherTextarea] = useState(
    selectedReason === "other"
  );
  const [otherReason, setOtherReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [componentKey, setComponentKey] = useState(0);
  const [interviewId, setInterviewId] = useState("");
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [rerender, setRerender] = useState(false);

  const candidateId = userResult?.userid;;
  const TeamList = useSelector((state) => state?.TeamTable?.result);
  const baseUrl = process.env.REACT_APP_API_PATH;

  let dispatch = useDispatch();

  useEffect(() => {
    // dispatch(CandidateInterviewPlanned(candidateId));
  }, [rerender, interviewList]);


  const closeModal = () => {
    setIsModalOpen(false);
  };


  // const handleCheck = (e, id) => {
  //   e.stopPropagation();
  //   AcceptInterview(id);
  // };

  const openModal = (e, intId) => {
    e.stopPropagation();
    setIsModalOpen(true);
    setInterviewId(intId);
  };


  // const AcceptInterview = (interviewId) => {
  //   const content = {
  //     isAcceptedByCandidate: "ACCEPTED",
  //     interviewId,
  //   };
  //   dispatch(JobsInterviewPlannedAcceptAction(content));

  //   const timeout = setTimeout(() => {
  //     dispatch(CandidateInterviewPlanned(candidateId));
  //   }, 600);
  //   setRerender(!rerender); // Toggle rerender state to trigger a re-render

  //   return () => {
  //     clearInterval(timeout);
  //   };
  // };


  const handleOtherReasonChange = (event) => {
    setOtherReason(event.target.value);
  };



  const handleReasonChange = (event) => {
    const value = event.target.value;
    setSelectedReason(value);
    // If "other" is selected, show the textarea
    setShowOtherTextarea(value === "other");
  };


  console.log(otherReason)
  const handleSubmit = async (e) => {
    setLoading(true);
    let timeout;
    try {
      if (selectedReason === "") {
        toast.error("Please select reason")
        setLoading(false);

        return

      }
      if (selectedReason === "other" && otherReason === "") {
        toast.error("This field cannot be empty")
        setLoading(false);

        return

      }
      const content = {
        declineReasonCandidate: selectedReason !== "other" ? selectedReason : otherReason,
        interviewId,
      };
      const response = await axios.put(
        `${baseUrl}/ebench/accept_or_reject_invitation?userRequestedProfileId=${interviewId}&acceptanceStatus=false&rejectedReason=${selectedReason ? selectedReason : otherReason}`,
        content,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.data;

      // timeout = setTimeout(() => {
      //   dispatch(CandidateInterviewPlanned(candidateId));
      // }, 1200);

      setLoading(false);
      setSelectedReason("");
      setSelectedCandidates([]);
      closeModal();
      setComponentKey((prevKey) => prevKey + 1);

      toast.success("Invitation Rejected");
      window.location.reload()

    } catch (error) {
      setLoading(false);
      console.error("Error occurred", error);
      toast.error(error?.response?.data?.status?.message);
    }

    return () => {
      clearTimeout(timeout);
    };
  };


  const handleSchedule = (e, item) => {
    e.stopPropagation();

    setCanInfo(item);
    setOpen(true);
  };

  // -----------------------------Accept-Popup-----------------------------------
  const handleAccept = (userRequestedProfileId) => {
    // Create a style element
    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
    .custom-confirm-button {
        background-color: #286a94 !important;
        color: white;
        border-bottom: 1px solid rgb(57, 57, 57);
    }
    .custom-title {
        border-bottom: 0.5px solid #adadad;
        color: #286a94 !important;
        padding-bottom: 10px;
    }
        .msg-paragraph {
        margin-top:10px;
    }
  `;
    // Append the style to the head of the document
    document.getElementsByTagName('head')[0].appendChild(style);

    const para = document.createElement('div');
    para.className = 'custom-paragraph';
    para.innerText = 'Are you sure you want to Accept?';

    const msgPara = document.createElement('div');
    msgPara.className = 'msg-paragraph';
    msgPara.innerText = 'By accepting this, your account on EBench will be temporarily suspended. You will receive a company account via email shortly.';

    const container = document.createElement('div');
    container.appendChild(para);
    container.appendChild(msgPara);

    Swal.fire({
      title: "Accept Invitation",
      html: container.outerHTML,
      showCancelButton: true,
      confirmButtonText: "Accept",
      customClass: {
        title: "custom-title",
        confirmButton: "custom-confirm-button"
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.put(`${baseUrl}/ebench/accept_or_reject_invitation?userRequestedProfileId=${userRequestedProfileId}&acceptanceStatus=true`);
          localStorage.clear();
          window.location.href = '/login';
          // toast.info('Your personal account has been deactivated, try logging in with your professional account', { autoClose: 10000 });
          console.log('API Response:', response.data);
        } catch (error) {
          console.error('Error accepting:', error);
          Swal.fire("Error", "There was an error accepting the invitation", "error");
        }
      }
    });
  };


  return (
    <div
      className="mt-4 common_shadow"
      style={location.pathname.includes('/admin/team-list') ? { width: '95%', margin: 'auto' } : { fontSize: "14px", marginInline: "7.5%" }}
    >
      <div className="card-header  common_table_header">
        {pathname == "/invitations"
          ? "Invitations Recieved"
          : "Requested Team Members"}
      </div>

      <div className="card-body">
        <div className="table-responsive">
          <table
            className="table-data"
            style={{ width: "100%", textAlign: "center" }}
          >
            <thead>
              <tr>
                <th className="fw_500" scope="col">
                  ID
                </th>
                <th className="fw_500" scope="col">
                  Candidate Name
                </th>
                {!limit && (
                  <th className="fw_500" scope="col">
                    Email
                  </th>
                )}
                {!limit && (
                  <th className="fw_500" scope="col">
                    Designation
                  </th>
                )}
                <th className="fw_500" scope="col">
                  Status
                </th>
                <th className="fw_500" scope="col">
                  Aadhaar Card Number
                </th>
                {pathname === "/invitations" && (
                  <th className="fw_500" scope="col">
                    Action
                  </th>
                )}
                {/* <th className="fw_500" scope="col">
                  Start Time
                </th>
                <th className="fw_500" scope="col">
                  Duration
                </th>

                {!limit && (
                  <th className="fw_500" scope="col">
                    Interview Type
                  </th>
                )} */}
                {/* {!limit && (
                  <th className="fw_500" scope="col">
                    Candidate Status
                  </th>
                )}
                {!limit && (
                  <th className="fw_500" scope="col">
                    Interviewer Status
                  </th>
                )} */}

                {/* {!limit && (
                  <th className="fw_500" scope="col">
                    Hiring Status
                  </th>
                )}
                {!limit && (
                  <th className="fw_500" scope="col">
                    Status
                  </th>
                )} */}
                {/* {!limit &&
                  (interviewList?.content?.interviewStatus == "COMPLETED" ||
                    interviewList?.content?.interviewStatus == "CANCELLED") && (
                    <th className="fw_500" scope="col">
                      Reschedule
                    </th>
                  )} */}

                {
                  // (interviewList?.content?.interviewStatus=="COMPLETED" || interviewList?.content?.interviewStatus =="CANCELLED") &&
                }
              </tr>
            </thead>
            <tbody>
              {interviewList &&
                interviewList?.map((item, i) => {
                  console.log("ITEM--", item);
                  return (
                    <>
                      {arr.map((element) => (
                        <>
                          <tr
                            // style={{ cursor: "pointer" }}
                            // onClick={() =>
                            //   navigate(
                            //     `/scheduled-more-info/${item.interviewId}`
                            //   )
                            // }
                            key={i}
                          >
                            <td>{item?.userRequestedProfileId}</td>
                            <td>
                              {item?.firstName} {item?.lastName}{" "}
                            </td>
                            <td>{item?.email}</td>
                            <td>{item?.currentDesignation}</td>
                            {/* <td>{item?.userRequestedProfileStatus}</td> */}
                            <td><div className={`w-100 m-auto mb-0 ${(item.userRequestedProfileStatus === 'REJECTED' || item.userRequestedProfileStatus === 'NOT_SHORTLISTED') ? 'red_status' : (item.userRequestedProfileStatus === "PENDING") ? 'yellow_status' : 'green_status'}`}>
                              {item.userRequestedProfileStatus === 'REJECTED' ? 'Rejected' : item.userRequestedProfileStatus === 'NOT_SHORTLISTED' ? 'Not ShortListed' : item.userRequestedProfileStatus === 'PENDING' ? 'In Progress' : 'Accepted'}
                            </div></td>
                            {/* <div className={`w-75 m-auto mb-0 ${(item.jobAcceptanceStatus === 'REJECTED' || item.jobAcceptanceStatus === 'NOT_SHORTLISTED') ? 'red_status' : (item.jobAcceptanceStatus==="PENDING" )? 'yellow_status' : 'green_status'}`}>
                                  {item.jobAcceptanceStatus === 'REJECTED' ? 'Rejected' : item.jobAcceptanceStatus === 'NOT_SHORTLISTED' ? 'Not ShortListed' : item.jobAcceptanceStatus === 'PENDING'? 'Pending':'Scheduled'}
                              </div> */}
                            {/* <td>{item.interviewDate.split(" ")[0]}</td> */}
                            <td>{item?.aadhaarCardNumber}</td>
                            {pathname === "/invitations" &&  (
                              item?.userRequestedProfileStatus === "PENDING" ? (
                                <td>
                                <FaCheck
                                  size={23}
                                  color="#286a94"
                                  className="me-3 pointer"
                                  onClick={() => handleAccept(item?.userRequestedProfileId)}
                                />

                                <MdOutlineCancel
                                  size={23}
                                  color="red"
                                  className="pointer"
                                  onClick={(e) =>
                                    openModal(e, item?.userRequestedProfileId)
                                  }
                                />
                              </td>
                              ) : (
                                <td>Done</td>
                              )
                            )}



                          </tr>
                        </>
                      ))}
                    </>
                  );
                })}
            </tbody>
          </table>
          {interviewList?.length === 0 && (
            <div className="text-center mt-5">
              <h5>No Invitations Found</h5>
            </div>
          )}


        </div>
      </div>
      <DeactivateModal
        isOpen={isModalOpen}
        onClose={closeModal}
        heading={"Reason for Rejection"}
      >
        <FormControl>
          <FormLabel id="demo-radio-buttons-group-label">Reasons
            <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            // defaultValue="female"
            name="radio-buttons-group"
            value={selectedReason}
            onChange={handleReasonChange}
          >
            <FormControlLabel
              className="mb-2"
              value="I am not available"
              control={<Radio />}
              label="I am not available"
            />

            <FormControlLabel
              className="mb-2"
              value="Better opportunities elsewhere"
              control={<Radio />}
              label="Better opportunities elsewhere"
            />

            <FormControlLabel
              className="mb-2"
              value="Lack of clarity about the role or expectations"
              control={<Radio />}
              label="Lack of clarity about the role or expectations"
            />

            <FormControlLabel
              className="mb-2"
              control={<Radio />}
              value={"other"}
              label="Others"
            //  onClick={handleOtherReason}
            />

            {showOtherTextarea && (
              <TextareaAutosize
                value={otherReason}
                onChange={handleOtherReasonChange}
                placeholder="Other Reason"
                minRows={5}
                maxRows={5}
              />
            )}
          </RadioGroup>

          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              variant="contained"
              className="common_btn"
              style={{
                background: "#1c6597",
                color: "#fff",
                marginRight: "10px",
                width: "100px",
                height: "40px",
              }}
              onClick={handleSubmit} // Add your submit logic here
            >
              {!loading ? "Submit" : <SpinLoader />}
            </button>
            {/* <button className="btn btn-danger rounded-0" onClick={closeModal}>
              Cancel
            </button> */}
          </div>
        </FormControl>
      </DeactivateModal>
    </div>
  );
};

export default RequestedProfileTable;
